var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kd-grafik-url__text",class:{
      'kd-grafik-url__text--rotated': _vm.isVertical,
      'kd-grafik-url__text--right': _vm.orientation === _vm.directions.RIGHT,
      'kd-grafik-url__text--left': _vm.orientation === _vm.directions.LEFT,
      'kd-grafik-url__text--bottom': _vm.orientation === _vm.directions.BOTTOM,
    }},[_vm._v("\n  "+_vm._s(_vm.url || 'www.hach.de')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }